// Set proper video url to background video players based on screen size
$('video[data-src-desktop]').each(function() {
    let $video = $(this),
        urlDesktop = $(this).data('src-desktop'),
        urlMobile = $(this).data('src-mobile'),
        urlNew;

    // if no source element exists yet for video
    if (!$video.find('source').length > 0) {

        if (typeof urlDesktop !== 'undefined') {

            urlNew = urlDesktop;

            if (viewport().width < 992) {
                if (typeof urlMobile !== 'undefined' && "" !== urlMobile) {
                    urlNew = urlMobile;
                }
            }

            let source = 'video/mp4';

            if (urlNew.indexOf('.webm') >= 0) {
                source = 'video/webm';
            }

            let desktopOnly = $video.attr('data-only-load-on-desktop');

            if (typeof desktopOnly !== 'undefined' && desktopOnly !== false && viewport().width < 992) {
                return false;
            }

            // append source element with url matching screen size
            $video.append('<source type="' + source + '" src="' + urlNew + '">');
        }
    }
});

// pause videos when they are outside viewport (mobile often only lets 1 video play simultaneously)
let observers = [];

startup = () => {
    let observerOptions = {
        threshold: [0, 1] // contains percentages (0 is zero, 1 is 100% of element visible in viewport in all directions) to trigger callback on
    }

    const $videos = $('video');

    let i = 0;

    $videos.each(function () {
        observers[i] = new IntersectionObserver(intersectionCallback, observerOptions);
        observers[i].observe($(this)[0]);
    });
};

function intersectionCallback(entries) {
    entries.forEach((entry) => {
        let $video = $(entry.target);

        if (entry.isIntersecting) {
            $video.trigger('play');
        } else {
            $video.trigger('pause');
        }
    });
}

startup();
